import { useEffect } from 'react'
import { useAppDispatch } from '@hooks/reduxHooks'
import { preparationLotService } from '@services/PreparationLotService'
import { upsertPreparationLot } from '@state/reducers/preparationLotReducer'

export function usePreparationLotSSE() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const unsubscribe = preparationLotService.subscribeToEvents((lot) => {
      dispatch(upsertPreparationLot(lot))
    })
    return unsubscribe
  }, [dispatch])
}
